<template>
<Card>
	<div>為了保障您的購物權益，請填寫聯絡資訊，並選擇取貨地點</div>
	<div :class="style.form">
		<label for="phone">您的手機號碼：</label>
		<input v-model="phoneNumber" type="tel" id="phone" :class="globalStyle.inputbox" required />
		<label for="name">您的姓名：</label>
		<input id="name" :value="identity.name" :class="globalStyle.inputbox" disabled />
		<label for="defaultBranch">您的取貨地點：</label>
		<select v-model="branchID" :class="globalStyle.inputbox" id="defaultBranch">
			<option v-for="branch in branches"
				:key="branch.BranchID"
				:value="branch.BranchID">
					{{ branch.BranchName }}
			</option>
		</select>
	</div>
	<div :class="globalStyle.button" @click="register">我已填寫完成</div>
</Card>
</template>

<script lang="ts">
import { computed, defineComponent, inject, ref, useCssModule } from 'vue'
import Swal from 'sweetalert2'
import { useIdentity, registerIdentity } from '@/composables/useIdentity'
import { useBranches } from '@/composables/useBranches'
import Card from '@/components/Card.vue'
import checkPhone from '@/utils/checkPhone'

export default defineComponent({
	components: {
		Card,
	},
	setup() {
		const phoneNumber = ref("")
		const branchID = ref(0)

		// 跳過BranchID為0的"未選取"與 民生 分店
		const branches = computed(() => (
			useBranches().value
				.filter(({ BranchID }) => (BranchID !== 0))
				.filter(({ BranchID }) => (BranchID !== 8))
        .sort((a, b) => a.BranchID - b.BranchID)
		))

		const register = async () => {
			if (phoneNumber.value.length === 0) {
				Swal.fire({
					icon: 'error',
					title: '好像有欄位漏填了',
					text: '請輸入您的手機號碼',
				})
				return
			}

			try {
				checkPhone(phoneNumber.value)
			} catch (e) {
				Swal.fire({
					icon: 'error',
					title: '發生了錯誤！',
					text: e.message,
				})
				return
			}

			if (!branchID.value || branchID.value === 0) {
				Swal.fire({
					icon: 'error',
					title: '好像有欄位漏填了',
					text: '請選擇您要取貨的地點',
				})
				return
			}

			try {
				await registerIdentity({
					phone: phoneNumber.value,
					defaultBranch: branchID.value,
				})
			} catch (e) {
				Swal.fire({
					icon: 'error',
					title: '發生了錯誤！',
					text: e.message,
				})
			}
		}

		return {
			globalStyle: inject<Record<string, string>>('globalStyle'),
			style: useCssModule(),
			identity: useIdentity(),
			branches,
			branchID,
			phoneNumber,
			register,
		}
	}
})
</script>

<style lang="scss" module>
.form {
	display: grid;
  grid-template-columns: max-content auto;
	gap: .2em;
	align-items: center;
	margin-top: .6em;
}
</style>
